import { useEffect, useState } from "react";

const DAY = 864e5;
// Christmas midnight in NZ (NZDT, UTC+13) = 24 Dec 11:00 UTC
const xmasUtc = (y) => Date.UTC(y, 11, 24, 11);

const target = (now) => {
  const y = new Date(now + 13 * 36e5).getUTCFullYear();
  return now >= xmasUtc(y) + DAY ? xmasUtc(y + 1) : xmasUtc(y);
};

const parts = (ms) => [
  ["Days", Math.floor(ms / DAY)],
  ["Hours", Math.floor(ms / 36e5) % 24],
  ["Mins", Math.floor(ms / 6e4) % 60],
  ["Secs", Math.floor(ms / 1e3) % 60],
];

export const ChristmasCountdown = () => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const left = target(now) - now;
  if (left <= 0) {
    return <p data-testid="christmas-countdown" className="font-display font-extrabold text-3xl sm:text-4xl mt-8">Merry Christmas!</p>;
  }

  return (
    <div data-testid="christmas-countdown" className="mt-8">
      <p className="font-mono-x text-xs uppercase tracking-[0.2em] font-bold text-white/90">Countdown to Christmas</p>
      <div className="mt-3 flex justify-center gap-2 sm:gap-4">
        {parts(left).map(([label, v]) => (
          <div key={label} data-testid={`countdown-${label.toLowerCase()}`}
            className="w-[72px] sm:w-24 rounded-2xl bg-white text-[var(--ink)] border-2 border-[var(--ink)] shadow-[4px_4px_0_#14101F] py-3 sm:py-4">
            <span className="block font-mono-x font-bold text-3xl sm:text-5xl leading-none tabular-nums">{String(v).padStart(2, "0")}</span>
            <span className="block text-xs font-semibold mt-1.5 uppercase tracking-wider">{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
